/**
 * Rows from GET /factions use `name` as the localized display label.
 * Canonical English keys for lookups (strategies, carousel art, costs) live in
 * `english_name` and `faction_name` (both the DB `factions.name` value).
 */

export function getFactionCanonicalName(factionRow) {
  if (!factionRow || typeof factionRow !== 'object') {
    throw new Error('getFactionCanonicalName: factionRow object is required');
  }
  const canonical = factionRow.english_name || factionRow.faction_name;
  if (typeof canonical !== 'string' || canonical.length === 0) {
    throw new Error(
      `getFactionCanonicalName: expected non-empty english_name or faction_name, keys=${Object.keys(factionRow).sort().join(', ')}`
    );
  }
  return canonical;
}

export function resolveFactionLabelToCanonical(label, factionsList) {
  if (typeof label !== 'string' || label.length === 0) {
    throw new Error('resolveFactionLabelToCanonical: label must be a non-empty string');
  }
  if (!Array.isArray(factionsList)) {
    throw new Error('resolveFactionLabelToCanonical: factionsList must be an array');
  }
  for (const f of factionsList) {
    const canonical = getFactionCanonicalName(f);
    if (canonical === label || f.name === label) {
      return canonical;
    }
  }
  throw new Error(`resolveFactionLabelToCanonical: unknown faction label "${label}"`);
}

export function buildFactionTranslationMap(factionsList) {
  if (!Array.isArray(factionsList)) {
    throw new Error('buildFactionTranslationMap: factionsList must be an array');
  }
  const translationMap = {};
  for (const faction of factionsList) {
    const en = getFactionCanonicalName(faction);
    if (typeof faction.name !== 'string' || faction.name.length === 0) {
      throw new Error(`buildFactionTranslationMap: missing localized name for ${en}`);
    }
    translationMap[en] = faction.name;
  }
  return translationMap;
}
